module.exports = __webpack_public_path__ + "img/kroll-logo.25068246.png";